import { createFileRoute } from '@tanstack/react-router';
import { lazy, Suspense } from 'react';

const PresentWindow = lazy(() =>
  import('../features/my-files/slides/present-window').then((module) => ({
    default: module.PresentWindow,
  })),
);

/**
 * Cửa sổ chiếu slide — APM-SLD-i, docs/plan-slides.md §6.2.
 *
 * Nằm ngoài `_app` (tiền lệ `/tg`, `/portal`): không `AppShell`, không menu,
 * không tour — màn chiếu chỉ có slide. Không gọi API nào: mọi dữ liệu tới qua
 * `BroadcastChannel` từ trình soạn đã mở nó, kênh là `?c=`.
 */
export const Route = createFileRoute('/present')({
  // `c` luôn bắt đầu bằng chữ (`newPresentChannelId`) nên `JSON.parse` của router không đổi nó thành số.
  validateSearch: (search: Record<string, unknown>): { c: string } => ({
    c: typeof search['c'] === 'string' ? search['c'] : '',
  }),
  component: function PresentRoute() {
    const { c } = Route.useSearch();
    return (
      <Suspense fallback={<div className="fixed inset-0 bg-black" />}>
        <PresentWindow channelId={c} />
      </Suspense>
    );
  },
});
